import { Fragment, ReactNode, useState } from 'react'

import PlayIcon from '@/assets/icons/play.svg?react'
import { cn } from '@/utils/style'

interface CollapseTableRowProps {
  colSpan: number
  children: ReactNode
  content: ReactNode
  tableClassName?: string
}

export function CollapseTableRow({
  children,
  content,
  colSpan,
  tableClassName,
}: CollapseTableRowProps) {
  const [isCollapse, setIsCollapse] = useState(false)

  return (
    <Fragment>
      <tr className="">
        <td colSpan={colSpan} className="td-card-container !px-0">
          <table className={cn('w-full tr-card table-fixed !overflow-visible', tableClassName)}>
            <tbody className="w-full">
              <tr
                className={cn('peer', { 'tr-collapse': isCollapse })}
                onClick={() => setIsCollapse(!isCollapse)}
              >
                {children}
                <td colSpan={1}>
                  <div className="w-full h-8 flex items-center justify-end">
                    <PlayIcon
                      className={cn('w-4 h-4 transition-transform duration-300', {
                        'rotate-90': isCollapse,
                      })}
                    />
                  </div>
                </td>
              </tr>
              {isCollapse && (
                <tr>
                  <td colSpan={colSpan} className="!px-0">
                    <div className="mt-[-16px]">{content}</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </Fragment>
  )
}
